import { UPDATE_PROMO_CODE, UPDATE_PROMO_CODE_SUCCESS, UPDATE_PROMO_CODE_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const updatePromoCodeReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_PROMO_CODE:
      return { ...state, loading: true };
    case UPDATE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PROMO_CODE_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default updatePromoCodeReducer;
